module.exports = __webpack_public_path__ + "fa1e87053f03b59b3fedd2e6dcbec1c5.MP3";